'use client';

import { RichTextViewer, richTextViewerTag } from '@ni/nimble-components/dist/esm/rich-text/viewer';
import { wrap } from '../../utilities/react-wrapper';

export { richTextViewerTag };
export { type RichTextViewer };
export const NimbleRichTextViewer = wrap(RichTextViewer);
